module.exports = __webpack_public_path__ + "img/a6.954d4253.jpg";